import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SystemUpdateTvIcon(props: IconProps) {
    return <Icon {...props} iconKey={"system_update_tv"}/>
}
